import React, { useEffect, useState } from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell,
} from 'recharts';
import analyticsService from '../../services/analyticsService';
import EmptyState from './EmptyState';
import type { AnalyticsFilters, DistributionResponse } from '../../types/analytics';

const DistributionHistogram: React.FC<{ filters: AnalyticsFilters }> = ({ filters }) => {
  const [data, setData] = useState<DistributionResponse | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const r = await analyticsService.getDistribution(filters, 20);
        if (!cancelled) setData(r);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [filters]);

  if (loading) return <div className="py-8 text-center text-sm text-gray-400">Loading…</div>;
  if (!data || !data.bins.length) return <EmptyState />;

  const points = data.bins.map(b => ({
    label: `${Math.round(b.x0)}…${Math.round(b.x1)}`,
    midpoint: (b.x0 + b.x1) / 2,
    count: b.count,
  }));

  return (
    <div>
      <div className="text-xs text-gray-500 dark:text-gray-400 mb-2">
        {data.tradeCount} trades, range ₹{Math.round(data.min).toLocaleString('en-IN')} … ₹{Math.round(data.max).toLocaleString('en-IN')}
      </div>
      <div style={{ width: '100%', height: 240 }}>
        <ResponsiveContainer>
          <BarChart data={points} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" opacity={0.18} />
            <XAxis dataKey="label" tick={{ fontSize: 10 }} interval="preserveStartEnd" />
            <YAxis tick={{ fontSize: 11 }} width={40} allowDecimals={false} />
            <Tooltip contentStyle={{ borderRadius: 6, fontSize: 12 }} />
            <Bar dataKey="count" name="Trades">
              {points.map((p, i) => (
                <Cell key={i} fill={p.midpoint >= 0 ? '#10b981' : '#ef4444'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DistributionHistogram;
